import { create } from 'zustand';

type AppState = {
	updateState: <T>(key: string, value: T) => void;
	loaded?: boolean;
	userLoaded?: boolean;
	delta?: number;
	errors?: { [key: string]: string };
	loginSuccess?: boolean;
	params?: { [key: string]: string }[];
	isCallingApi?: boolean;
	getParam: (key: string) => string;
	getError: (error: any) => string;
};

export const useStore = create<AppState>((set, get) => ({
	loaded: false,
	userLoaded: false,
	delta: 0,
	errors: {},
	params: [],
	loginSuccess: false,
	isCallingApi: false,
	getParam: (key: string) => {
		const params = get().params
		return params?.[key as any] as any
},
	getError: (error: any) => {
		const errors = get().errors
		const key = (error?.code || error?.message) as string
		
		return errors?.[key] || `Hệ thống chưa thể thực hiện thao tác của bạn: ${key}`
},
	updateState: <T>(key: string, value: T) =>
		set(() => ({
			[key]: value,
		})),
}));
